import React from 'react';
import { motion } from 'framer-motion';
import { Phone } from 'lucide-react';

const Header = () => {
  return (
    <motion.header 
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className="bg-white/75 backdrop-blur-md border-b border-primary/10 shadow-sm"
    >
      <div className="px-4 sm:px-6 py-4 max-w-6xl mx-auto">
        <div className="flex items-center justify-between gap-3 sm:gap-4">
          <div className="flex items-center gap-3 sm:gap-4 min-w-0">
            {/* Logo */}
            <motion.div
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.2 }}
              className="w-12 h-12 sm:w-14 sm:h-14 rounded-2xl bg-white shadow-lg shadow-neutral-200/70 border border-neutral-200 flex items-center justify-center flex-shrink-0"
            >
            <svg 
              viewBox="0 0 500 500" 
              className="w-8 h-8 sm:w-9 sm:h-9"
              fill="none"
            >
              <polygon 
                points="250.2,60.3 266.9,88.7 245.6,125.1 264.7,158 285.9,121.7 302.5,150.2 262.7,218.6 229.7,218.6 247.9,186.9 228.9,154.2 191.4,218.8 158.2,218.8"
                fill="#111111"
              />
              <polygon 
                points="150.6,232 183.6,232.1 156.1,280.2 196,280.5 224.6,231.9 255.1,233.2 217.8,297.8 250.4,362.3 219.3,362.4 189.3,309.3 139.5,309.3 108.9,362.3 74.8,362.3"
                fill="#111111"
              />
              <polygon 
                points="349.4,231.8 269.4,232 269.3,311.9 361.2,311.9 373.9,333.9 290.3,334 290.2,324.9 269.2,324.8 269,362.8 425.2,362.6 378.7,283 290.4,283 290.3,260.8 335.2,260.6 339.9,269.8 371.6,269.8"
                fill="#111111"
              />
              <polygon 
                points="256.7,258.9 234.7,299.2 256.7,339.3"
                fill="#B882F0"
              />
              <polygon 
                points="309.5,163.4 276.5,220.5 342.4,220.4"
                fill="#111111"
              />
              <polygon 
                points="127.3,362.1 196.7,362.4 177.2,323.7 149.7,323.7"
                fill="#6634F1"
              />
            </svg>
          </motion.div>

          {/* Title */}
          <div className="min-w-0">
            <h1 className="text-lg sm:text-xl font-bold text-primary truncate">
              HindukushSoft Technologies
            </h1>
            <p className="text-xs sm:text-sm text-neutral-600 font-medium leading-tight">
              Virtual Internship Program
              <span className="hidden sm:inline text-secondary font-semibold ml-2">Batch-IV</span>
            </p>
          </div>
          </div>

          {/* Call to Action */}
          <a 
            href="tel:0943219679"
            className="flex items-center gap-2 text-primary hover:text-secondary transition-colors flex-shrink-0"
          >
              <Phone className="w-4 h-4 sm:w-5 sm:h-5 text-primary flex-shrink-0" />
            <span className="text-xs sm:text-sm font-semibold">
              <span className="block text-xs text-secondary">Need Help?</span>
              <span className="block">0943 219679</span>
            </span>
          </a>
        </div>
      </div>

      {/* Gold Accent Line */}
      <div className="h-1 bg-primary" />
    </motion.header>
  );
};

export default Header;
